import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  loader: false,
  questionLoader: false,
  clientLoader: false,
  getList: false,
  alertMsg: '',
  catgoriesList: [],
  selectedCategories: [],
  years: [],
  questionnaireNames: [],
  questionData: [],
  isFetch: false
};

const categorySlice = createSlice({
  name: 'category',
  initialState: INITIAL_STATE,
  reducers: {
    getCategoryList(state) {
      state.loader = true;
      state.getList = false;
      state.isFetch = false;
    },
    setCategories(state, { payload }) {
      state.loader = false;
      state.getList = true;
      state.catgoriesList = payload;
    },
    startLoading(state) {
      state.loader = true;
      state.getList = false;
    },
    stopLoading(state) {
      state.loader = false;
    },
    setNewUser(state) {
      state.loader = false;
      state.getList = true;
    },
    resetStateOnUnmount(state) {
      state.getList = false;
      state.alertMsg = '';
    },
    setSelectedCategories(state, { _, payload }) {
      state.selectedCategories = payload;
    },
    getQuestionList(state) {
      state.questionLoader = true;
      state.getList = false;
    },
    stopQuesLoading(state) {
      state.questionLoader = false;
    },
    getClientList(state) {
      state.clientLoader = true;
      state.getList = false;
    },
    stopClientLoading(state) {
      state.clientLoader = false;
    },
    starQuestiontLoading(state) {
      state.loader = true;
      state.getList = false;
    },
    setYears(state, { payload }) {
      state.questionLoader = false;
      state.getList = true;
      state.years = payload;
    },
    setQuestionnaireNames(state, { payload }) {
      state.questionLoader = false;
      state.getList = true;
      state.questionnaireNames = payload;
    },
    setClientNames(state, { payload }) {
      state.clientLoader = false;
      state.getList = true;
      state.clientNames = payload;
    },
    setQuestionData(state, { payload }) {
      state.isFetch = true;
      state.questionLoader = false;
      state.getList = true;
      state.questionData = payload;
    },
    emptyQuestionData(state) {
      state.isFetch = false;
      state.questionLoader = false;
      state.getList = false;
      state.questionData = [];
    }
  }
});

export const categoryAction = categorySlice.actions;

export default categorySlice.reducer;
